import type { FC } from 'react';

type IconProps = {
    className?: string;
};

export const LegendIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="4" y="6" width="4" height="4" fill="#9CA3AF" />
        <rect x="4" y="14" width="4" height="4" fill="#D1D5DB" />
        <rect x="10" y="6" width="10" height="4" fill="#6B7280" />
        <rect x="10" y="14" width="10" height="4" fill="#6B7280" />
    </svg>
);

export const DonutIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 3a9 9 0 1 0 9 9h-9V3z" fill="#9CA3AF" />
        <path d="M12 12h9A9 9 0 0 1 12 21v-9z" fill="#D1D5DB" />
    </svg>
);

export const StackedIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="3" y="14" width="4" height="7" fill="#4B5563" />
        <rect x="10" y="10" width="4" height="11" fill="#9CA3AF" />
        <rect x="17" y="6" width="4" height="15" fill="#D1D5DB" />
    </svg>
);
